/**
 * src/components/mobile/MobileLayout.jsx
 */
import { useState, useRef, useEffect } from 'react';

const _API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api').replace(/\/api$/, '');
import { useNavigate } from 'react-router-dom';

const TOP = {
  position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200,
  background: '#1a1f2e',
  display: 'flex', alignItems: 'center', gap: 10,
  height: 54,
  boxShadow: '0 2px 8px rgba(0,0,0,.3)',
  padding: '0 14px',
};
const BOT = {
  position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 200,
  background: '#fff',
  borderTop: '1px solid #e2e8f0',
  display: 'flex',
  paddingBottom: 'env(safe-area-inset-bottom,0px)',
  boxShadow: '0 -2px 8px rgba(0,0,0,.06)',
};
const NAV_ITEMS = [
  { key:'home',       label:'Home',        path:'/mobile',             icon:HomeIcon   },
  { key:'assets',     label:'Assets',      path:'/mobile/assets',      icon:AssetsIcon },
  { key:'workorders', label:'Work Orders', path:'/mobile/work-orders', icon:WOIcon     },
];

export default function MobileLayout({ children, active, showBack=false, title='' }) {
  const navigate = useNavigate();
  const [showProfile, setShowProfile] = useState(false);
  const profileRef = useRef(null);

  const user = (() => {
    try { return JSON.parse(localStorage.getItem('iassets_user') || '{}'); }
    catch { return {}; }
  })();
  const initial   = user.name?.[0]?.toUpperCase() || 'U';
  const avatarRaw  = user.avatar || user.profile_picture || user.photo || '';
  const avatarSrc  = (() => {
    if (!avatarRaw) return null;
    if (avatarRaw.startsWith('http')) return avatarRaw;           // already full URL
    if (avatarRaw.startsWith('/'))    return `${_API_BASE}${avatarRaw}`;  // has path
    return `${_API_BASE}/uploads/avatars/${avatarRaw}`;           // just filename
  })();

  useEffect(() => {
    const fn = e => {
      if (profileRef.current && !profileRef.current.contains(e.target))
        setShowProfile(false);
    };
    document.addEventListener('mousedown', fn);
    document.addEventListener('touchstart', fn);
    return () => {
      document.removeEventListener('mousedown', fn);
      document.removeEventListener('touchstart', fn);
    };
  }, []);

  const logout = () => {
    localStorage.removeItem('iassets_token');
    localStorage.removeItem('iassets_user');
    window.dispatchEvent(new Event('iassets_auth_change'));
    navigate('/login', { replace: true });
  };

  const MENU = [
    { icon:'👤', label:'My Profile',      action:()=>navigate('/mobile/profile') },
   /*  { icon:'✏️', label:'Edit Profile',    action:()=>{ navigate('/mobile/profile'); setTimeout(()=>window.dispatchEvent(new CustomEvent('mobile-profile-tab',{detail:'edit'})),200); } },
    { icon:'🔑', label:'Change Password', action:()=>{ navigate('/mobile/profile'); setTimeout(()=>window.dispatchEvent(new CustomEvent('mobile-profile-tab',{detail:'password'})),200); } }, */
    { icon:'🚪', label:'Logout',           action:logout, danger:true },
  ];

  return (
    <div style={{ background:'#f0f2f5', minHeight:'100dvh',
      paddingTop:54, paddingBottom:62,
      fontFamily:'-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif' }}>

      {/* TOP BAR */}
      <div style={TOP}>
        {showBack ? (
          <>
            <button onClick={()=>navigate(-1)}
              style={{ background:'none', border:'none', cursor:'pointer',
                color:'#fff', padding:'4px 6px 4px 0', lineHeight:1,
                display:'flex', alignItems:'center', flexShrink:0 }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 12H5M12 5l-7 7 7 7"/>
              </svg>
            </button>
            <span style={{ flex:1, fontSize:15, fontWeight:700, color:'#fff',
              overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
              {title}
            </span>
            <button onClick={()=>navigate('/mobile')}
              style={{ background:'none', border:'none', cursor:'pointer',
                color:'#94a3b8', fontSize:18, padding:4, lineHeight:1, marginRight:4 }}>
              🏠
            </button>
          </>
        ) : (
          <>
            <div style={{ display:'flex', flexDirection:'column', gap:3, padding:'4px 2px', flexShrink:0 }}>
              {[0,1,2].map(i=>(
                <div key={i} style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:2 }}>
                  <div style={{ width:5, height:5, borderRadius:1, background:'#94a3b8' }}/>
                  <div style={{ width:5, height:5, borderRadius:1, background:'#94a3b8' }}/>
                </div>
              ))}
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:6, flex:1 }}>
              <span style={{ background:'#dc2626', color:'#fff', fontWeight:800,
                fontSize:9, letterSpacing:'.1em', padding:'3px 7px',
                borderRadius:4, flexShrink:0 }}>STAR</span>
              <span style={{ fontSize:10, color:'#94a3b8', fontWeight:600, marginRight:2 }}>▶</span>
              <span style={{ fontSize:14, fontWeight:700, color:'#fff', letterSpacing:'.06em' }}>I IASSET</span>
            </div>
          {/*   <button onClick={()=>navigate('/mobile/search')}
              style={{ background:'none', border:'none', cursor:'pointer',
                color:'#94a3b8', fontSize:18, padding:4, lineHeight:1 }}>🔍</button> */}
          </>
        )}

        {/* Profile avatar */}
        <div ref={profileRef} style={{ position:'relative', flexShrink:0 }}>
          <div onClick={()=>setShowProfile(v=>!v)}
            style={{ width:32, height:32, borderRadius:'50%',
              background:'#3b82f6', display:'flex', alignItems:'center',
              justifyContent:'center', color:'#fff', fontSize:13, fontWeight:700,
              cursor:'pointer', userSelect:'none', overflow:'hidden',
              border:showProfile ? '2px solid #93c5fd' : '2px solid transparent',
              transition:'border .15s' }}>
            {avatarSrc
              ? <img src={avatarSrc} alt={initial}
                  style={{ width:'100%', height:'100%', objectFit:'cover',maxWidth:'100%', maxHeight:'100%' }}
                  onError={e => { e.target.style.display='none'; }}/>
              : initial}
          </div>

          {showProfile && (
            <div style={{ position:'absolute', top:42, right:0,
              background:'#fff', borderRadius:12, width:210,
              boxShadow:'0 8px 32px rgba(0,0,0,.18)',
              border:'1px solid #e2e8f0', overflow:'hidden', zIndex:300,
              animation:'fadeIn .15s ease' }}>
              <style>{'@keyframes fadeIn{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:translateY(0)}}'}</style>
              <div style={{ padding:'12px 14px', borderBottom:'1px solid #f1f5f9', background:'#f8fafc' }}>
                <div style={{ fontSize:13, fontWeight:700, color:'#1a1f2e' }}>{user.name||'User'}</div>
                <div style={{ fontSize:11, color:'#94a3b8', marginTop:2,
                  overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{user.email||'' }</div>
              </div>
              {MENU.map(item=>(
                <button key={item.label}
                  onClick={()=>{ setShowProfile(false); item.action(); }}
                  style={{ width:'100%', padding:'11px 14px',
                    display:'flex', alignItems:'center', gap:10,
                    background:'none', border:'none', cursor:'pointer',
                    borderBottom:'1px solid #f8fafc', textAlign:'left',
                    color:item.danger ? '#dc2626' : '#374151',
                    fontSize:13, fontWeight:500 }}>
                  <span style={{ fontSize:16, width:22, textAlign:'center' }}>{item.icon}</span>
                  {item.label}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {children}

      {/* BOTTOM NAV */}
      <div style={BOT}>
        {NAV_ITEMS.map(item=>{
          const isActive = active===item.key;
          const Icon = item.icon;
          return (
            <button key={item.key} onClick={()=>navigate(item.path)}
              style={{ flex:1, display:'flex', flexDirection:'column',
                alignItems:'center', justifyContent:'center',
                gap:3, padding:'10px 4px 8px',
                background:'none', border:'none', cursor:'pointer',
                color:isActive ? '#1a1f2e' : '#94a3b8' }}>
              <Icon size={22} active={isActive}/>
              <span style={{ fontSize:10, fontWeight:isActive?700:500 }}>{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

function HomeIcon({size=22,active}){return(<svg width={size} height={size} viewBox="0 0 24 24" fill={active?'#1a1f2e':'none'} stroke={active?'#1a1f2e':'#94a3b8'} strokeWidth="1.8" strokeLinecap="round"><path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"/><path d="M9 21V12h6v9"/></svg>);}
function AssetsIcon({size=22,active}){return(<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={active?'#1a1f2e':'#94a3b8'} strokeWidth="1.8" strokeLinecap="round"><rect x="3" y="3" width="8" height="8" rx="1"/><rect x="13" y="3" width="8" height="8" rx="1"/><rect x="3" y="13" width="8" height="8" rx="1"/><rect x="13" y="13" width="8" height="8" rx="1"/></svg>);}
function WOIcon({size=22,active}){return(<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={active?'#1a1f2e':'#94a3b8'} strokeWidth="1.8" strokeLinecap="round"><rect x="5" y="2" width="14" height="20" rx="2"/><path d="M9 7h6M9 11h6M9 15h4"/></svg>);}
